<template>
  <div class="Columnbanner">
    <img
      v-if="banner"
      class="absolute left-1/2 transform -translate-x-1/2"
      :src="banner"
      alt=""
    />
    <div class="stand relative">
      <slot></slot>
    </div>
    <MyBreadcrumb v-if="isBreadcrumb" />
  </div>
</template>

<script>
import MyBreadcrumb from "./MyBreadcrumb";
export default {
  name: "Columnbanner",
  components: {
    MyBreadcrumb,
  },
  props: {
    banner: {
      type: String,
    },
    isBreadcrumb: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.Columnbanner {
  .stand {
    height: 250px;
  }
  img {
    /* top: 154px; */
    object-fit: cover;
    height: 250px;
    width: 100%;
    min-width: 1400px;
  }
}
</style>
